import { HttpErrorResponse } from "@angular/common/http";
import { createAction } from "@ngrx/store";

import { AttachSignParams, MobileEdsAuth, SignAParams, SignedSCCryptoDto } from "@helper/abstraction/sccrypto";
import { UserSignToken } from "@helper/abstraction/user";

export const getTokenForCertificateBinding = createAction(
	"[SCCrypto] Get Token",
	(base64?: boolean): { base64?: boolean } => ({ base64 })
);
export const getTokenForCertificateBindingSuccess = createAction(
	"[SCCrypto]  Get Token Success",
	(payload: UserSignToken): { token: UserSignToken } => ({ token: payload })
);
export const getTokenForCertificateBindingError = createAction(
	"[SCCrypto]  Get Token Error",
	(payload: Error): { error: Error } => ({ error: payload })
);

export const signA = createAction(
	"[SCCrypto] Sign A",
	(value: SignAParams, token: number[], tokenBase64: string): { value: SignAParams; token: number[]; tokenBase64: string } => ({ value, token, tokenBase64 })
);
export const signASuccess = createAction(
	"[SCCrypto] Sign A Success",
	(value: SignedSCCryptoDto, token: number[], tokenBase64: string): { value: SignedSCCryptoDto; token: number[]; tokenBase64: string } => ({ value, token, tokenBase64 })
);
export const signAError = createAction(
	"[SCCrypto] Sign A Error",
	(payload: SignedSCCryptoDto): { error: SignedSCCryptoDto } => ({ error: payload })
);

export const bindCertificateToUser = createAction(
	"[SCCrypto] Bind Certificate To User",
	(payload: AttachSignParams, base64?: boolean): { value: AttachSignParams; base64?: boolean } => ({ value: payload, base64 })
);
export const bindCertificateToUserSuccess = createAction(
	"[SCCrypto] Bind Certificate To User Success",
	(certificateName?: string, certificateSerialNumber?: string): { certificateName?: string; certificateSerialNumber?: string } => ({ certificateName, certificateSerialNumber })
);
export const bindCertificateToUserError = createAction(
	"[SCCrypto] Bind Certificate To User Error",
	(payload: HttpErrorResponse): { error: HttpErrorResponse } => ({ error: payload })
);

export const attachCryptoMobile = createAction(
	"[SCCrypto] Attach Crypto Mobile",
	(mobileEds: MobileEdsAuth): { mobileEds: MobileEdsAuth } => ({ mobileEds })
);
export const attachCryptoMobileSuccess = createAction(
	"[SCCrypto] Attach Crypto Mobile Success",
	(mobileEds?: MobileEdsAuth): { mobileEds?: MobileEdsAuth } => ({ mobileEds })
);
export const attachCryptoMobileError = createAction(
	"[SCCrypto] Attach Crypto Mobile Error",
	(payload: HttpErrorResponse): { error: HttpErrorResponse } => ({ error: payload })
);

export const authorizeCryptoMobile = createAction("[SCCrypto] Authorize Crypto Mobile");
export const authorizeCryptoMobileSuccess = createAction(
	"[SCCrypto] Authorize Crypto Mobile Success",
	(mobileEds?: MobileEdsAuth): { mobileEds?: MobileEdsAuth } => ({ mobileEds })
);
export const authorizeCryptoMobileError = createAction(
	"[SCCrypto] Authorize Crypto Mobile Error",
	(payload: HttpErrorResponse): { error: HttpErrorResponse } => ({ error: payload })
);

export const detachCryptoMobile = createAction("[SCCrypto] Detach Crypto Mobile");
export const detachCryptoMobileSuccess = createAction(
	"[SCCrypto] Detach Crypto Mobile Success"
);
export const detachCryptoMobileError = createAction(
	"[SCCrypto] Detach Crypto Mobile Error",
	(payload: Error): { error: Error } => ({ error: payload })
);

export const unbindCertificateByUser = createAction("[SCCrypto] Unbind Certificate By User");
export const unbindCertificateBYUserSuccess = createAction(
	"[SCCrypto] Unbind Certificate By User Success"
);
export const unbindCertificateByUserError = createAction(
	"[SCCrypto] Unbind Certificate By User Error",
	(payload: Error): { error: Error } => ({ error: payload })
);
